module.exports = __webpack_public_path__ + "fixar.png?53d58db36682f841630f18656b350b1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fixar.png
// module id = 880
// module chunks = 0